import SwiperCarousel from '../utils/swiper-carousel';

export default (element) => {
  const el = element.querySelector('[data-routine-carousel]');

  if (!el) return;

  const init = () => {
    // eslint-disable-next-line no-new
    new SwiperCarousel(el, {
      slidesPerView: 1.2,
      spaceBetween: 15,
      allowTouchMove: true,
      centeredSlides: true,
      navigation: {
        nextEl: element.querySelector('.next'),
        prevEl: element.querySelector('.prev'),
      },
      breakpoints: {
        768: {
          spaceBetween: 20,
          slidesPerView: 4,
          centeredSlides: false,
          centerInsufficientSlides: true,
        },
      },
      mousewheel: {
        forceToAxis: true,
      },
    });
  };

  init();
};
